import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"
const urlAddon = "Addon"

export const getExtraCotizacion = async ({ IdCotizacion }) => {
    return await axios.get(`${APIURL}/${urlAddon}/Quotation/${IdCotizacion}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}

export const putExtraCatalogo = async ({ IdExtra, Nombre, Descripcion }) => {
    return await axios.put(`${APIURL}/${urlAddon}/Extra/${IdExtra}`, {
        Nombre,
        Descripcion
    },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error)
        })
};
export const putExtraPaquetePrecio = async ({ IdPaquete, IdExtra, Precio, Descripcion }) => {
    return await axios.put(`${APIURL}/${urlAddon}/Package/Extra/${IdPaquete}/${IdExtra}`, {
        Precio,
        Descripcion
    },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error)
        })
};
